import { dateWithoutHour, isWeekend, getWeekNumber } from "../../functions";
import { MonthlyUserPlanningTimeSlot } from "./MonthlyUserPlanningTimeSlot";

export const MonthlyUserPlanningDay = (props) => {
    const { datePlanning, timeSlots, selectedTimeSlots, isPublicHoliday } = props;

    function handleClickDate(val, ctrlKey) {
        props.onClickDate(val, ctrlKey);
    };

    function handleClickTimeSlots(tsId, ctrlKey) {
        props.onClickTimeSlots(...tsId, ctrlKey);
    };

    function isSelected(timeSlot) {
        return selectedTimeSlots.some(sel => timeSlot.id.includes(sel));
    };

    const mergedTimeSlots = () => {
        const mts = timeSlots?.map((timeSlot, i) => {
            return {'id' : [timeSlot.id], 'hour_type_id' : timeSlot.hour_type_id, 'hour_type' : timeSlot.hour_type, 'start_date' : timeSlot.start_date, 'end_date' : timeSlot.end_date, 'state': timeSlot.state};
        });
        let i = mts.length - 1;
        while (i > 0) {
            if (mts[i].hour_type.id === mts[i - 1].hour_type.id) {
                mts[i - 1].end_date = mts[i].end_date;
                mts[i - 1].id.push(...mts[i].id);
                mts.splice(i, 1);
            }
            i--;
        }
        return mts;
    };

    const dateStr = (aDate) => {
        return (aDate.getDay() === 1 ? "(Sem. " + getWeekNumber(aDate) + ") " : "") + aDate.toLocaleDateString().substring(0, 5)
    }

    return (
        <div className="relative w-full p-0 flex flex-wrap m-1 group">
            <div className="absolute h-auto z-10 p-1 text-xm bg-slate-100/50 place-items-center group-hover:bg-slate-100 hover:shadow-sm cursor-pointer" onClick={(e => { e.preventDefault(); handleClickDate(datePlanning, e.ctrlKey) })}>
                <span className={"w-full text-center " + (isPublicHoliday === true? "text-red-500" : "text-slate-700")}>{dateStr(datePlanning)}</span>
            </div>
            <div className={"h-full flex shrink text-center text-xm align-top p-1 gap-1 w-full " + (isWeekend(datePlanning) ? "bg-green-50" : "bg-white")}>
                {mergedTimeSlots().map((timeSlot, index) =>
                    <MonthlyUserPlanningTimeSlot
                        key={index}
                        timeSlot={timeSlot}
                        date={dateWithoutHour(datePlanning)}
                        onClickTimeSlots={handleClickTimeSlots}
                        selected={isSelected(timeSlot)}
                    />
                )}
            </div>
        </div>
    );
};
